import React from "react";
import PracticeInfo from "../components/PracticeInfo";
import ContactUs from "../components/ContactUs";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="Text__Body">
      <span className="eyebrow">Get In Touch</span>
      <h1>Contact Monument Dental</h1>
      <p className="lead">
        Have a question or ready to schedule? Reach out and our team will be
        happy to help.
      </p>
      <div className="contact-grid">
        <PracticeInfo />
        <ContactUs />
      </div>
    </div>
  );
};

export default Contact;
